var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'toggle-disabled': _vm.disabled }},[_c('div',{staticClass:"d-flex toggle-container"},[_c('div',{staticClass:"flex-grow-1"},[_c('v-chip',{staticClass:"w-100 left-option justify-center",class:[
          _vm.scope === _vm.$constants.SEARCH_SCOPES.site
            ? 'active-button'
            : 'regular-button',
          { 'cursor-default': _vm.disabled },
        ],attrs:{"small":""},on:{"click":function($event){return _vm.$emit('change', _vm.$constants.SEARCH_SCOPES.site)}}},[_vm._v(_vm._s(_vm.$t('common.my_site'))+"\n      ")])],1),_c('div',{staticClass:"flex-grow-1"},[_c('v-chip',{staticClass:"w-100 right-option justify-center",class:[
          _vm.scope === _vm.$constants.SEARCH_SCOPES.global
            ? 'active-button'
            : 'regular-button',
          { 'cursor-default': _vm.disabled },
        ],attrs:{"small":""},on:{"click":function($event){return _vm.$emit('change', _vm.$constants.SEARCH_SCOPES.global)}}},[_vm._v(_vm._s(_vm.$t('common.all'))+"\n      ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }